import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {inject} from '@angular/core';
import {catchError, map, switchMap, take} from 'rxjs/operators';
import {of} from 'rxjs';
import {Auth, IdTokenResult, user} from '@angular/fire/auth';
import {environment} from '../../environments/environment';
import {EhrClaims} from '../_interfaces/ehr-claims.interface';

export const authenticationGuard: CanActivateFn = (_route, state) => {
  const auth = inject(Auth);
  const router = inject(Router);
  const toLogin = (): UrlTree =>
    router.createUrlTree(['login'], {queryParams: {redirectURL: state.url}});

  const user$ = user(auth); // Observable<User | null>

  return user$.pipe(
    take(1),
    // Never return UrlTree here; return null when there is no user
    switchMap(u => {
      if (!u) return of<IdTokenResult | null>(null);
      return u.getIdTokenResult(true);
    }),
    map(token => {
      if (!token) return toLogin();

      const claims = (token.claims ?? {}) as EhrClaims;

      if (!environment.production) {
        console.log('Auth Guard claims: ', claims);
      }

      const ok = !!claims.orgId && !!claims.isLocationUser && !!claims.locationUserId;

      return ok ? true : toLogin();
    }),
    catchError(err => {
      if (!environment.production) {
        console.error('Error at Auth Guard => ', err);
      }
      return of(toLogin());
    })
  );
};
